// @flow
import {
  REFRESH_TOKEN_REQUESTING,
  LOGIN_FAILED,
  ACCESS_TOKEN_REQUESTING,
  LOGIN_SUCCESS,
  UPDATE_TOKENS,
  LOGOUT,
  REQUEST_CANDIDATE_ID_SUCCESS,
  REQUEST_CANDIDATE_ID_FAILURE
} from './constants';

import type { Action, LoginError } from '../types';

export const requestRefreshToken = (email: string, password: string): Action => ({
  type: REFRESH_TOKEN_REQUESTING,
  email,
  password
});

export const requestAccessToken = (refreshToken: string): Action => ({
  type: ACCESS_TOKEN_REQUESTING,
  refreshToken
});

export const failedLogin = (error: LoginError): Action => ({
  type: LOGIN_FAILED,
  error
});

export const successLogin = (refreshToken: string, accessToken: string): Action => ({
  type: LOGIN_SUCCESS,
  refreshToken,
  accessToken
});

export const updateTokens = (refreshToken: string, accessToken: string): Action => ({
  type: UPDATE_TOKENS,
  refreshToken,
  accessToken
});

export const logout = (): Action => ({
  type: LOGOUT
});

export const requestCandidateIdSuccess = (data: any): Action => ({
  type: REQUEST_CANDIDATE_ID_SUCCESS,
  data
});

export const requestCandidateIdFailure = (): Action => ({
  type: REQUEST_CANDIDATE_ID_FAILURE
});
